<template>
  <div class="block">
    <header>
      <div class="back" @click="backToHome">返回上一页</div>
    </header>
    <div class="productionWrap">
      <div class="pHeader">
        <img :src="image" />
        <h4 :title="name">{{ name }}</h4>
      </div>
      <div class="pBody">
        <div class="pInner">
          <div class="pInfo">
            <div class="price">¥ {{ price }}</div>
            <div class="stock">
              <span>已有{{ sell_num }}人兑换</span>
              <span>库存{{ stock === 9999 ? stock : stock - sell_num }}</span>
            </div>
          </div>
          <el-button
            type="primary"
            :class="{ disabled: btnDisabled }"
            @click="exchangeBtnClicked"
            >兑换</el-button
          >
          <div
            v-if="month_buy"
            class="cornerMark"
            :class="{ disabled: buy_num == month_buy }"
          >
            每月限购{{ buy_num || 0 }}/{{ month_buy }}
          </div>
        </div>
        <div class="pDesc">
          <div>商品说明：</div>
          <div v-html="txt" />
        </div>
      </div>
    </div>
    <el-dialog
      title="收货信息"
      :visible.sync="showExchangeDialog"
      width="600px"
      @close="resetForm('form')"
    >
      <el-form
        :model="form"
        ref="adressForm"
        :rules="rules"
        label-width="94px"
        :inline="false"
        size="normal"
        class="exchangeForm"
      >
        <el-form-item label="收货人姓名" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="省市" prop="provincesCity">
          <el-input v-model="form.provincesCity"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input type="textarea" v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label="联系手机号" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-alert
            title="提交后无法修改，请注意填写正确后再提交"
            type="error"
            :closable="false"
          >
          </el-alert>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import mixins from '../../../mixins/exchangeShop/productioDetail.mixins';
export default {
  mixins: [mixins],
};
</script>
<style
  src="../../../style/exchange-shop/pc/common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.block {
  min-height: 440px;
}
.productionWrap {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 27px;
  .pHeader {
    width: 174px;
    height: 208px;
    border: 1px solid #ffcc40;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 30px;
    img {
      width: 150px;
      height: 150px;
    }
    h4 {
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #262626;
      line-height: 28px;
      white-space: nowrap;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 160px;
      margin-top: 8px;
    }
  }
  .pBody {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    .pInner {
      width: 608px;
      height: 120px;
      background: #f7f7fa;
      border-radius: 6px;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 26px 0 22px;
      .pInfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .price {
          font-size: 26px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #262626;
          line-height: 37px;
          margin-bottom: 10px;
        }
        .stock {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
          span {
            margin-right: 38px;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      ::v-deep .el-button {
        width: 128px;
        height: 40px;
        background: #fd9b21;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        &.disabled {
          background-color: #d9d9d9;
          border-color: #d9d9d9;
        }
      }
      .cornerMark {
        min-width: 93px;
        width: fit-content;
        height: 22px;
        padding: 0 10px;
        background: #3b9aff;
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 22px;
        white-space: nowrap;
        position: absolute;
        top: 0;
        left: 0;
        &.disabled {
          background-color: #ccc;
        }
      }
    }
    .pDesc {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #878d99;
      line-height: 20px;
      margin-top: 10px;
    }
  }
}
::v-deep .el-dialog__header {
  padding: 20px 32px 10px;
}
::v-deep .el-dialog__body {
  padding: 18px 36px 46px;
}
.exchangeForm {
  ::v-deep textarea {
    width: 360px;
    height: 120px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: 22px;
  }
  ::v-deep .el-input__inner {
    width: 360px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: 22px;
  }
  ::v-deep .el-button {
    width: 321px;
    height: 54px;
    background: #fd9b21;
    border-radius: 8px;
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 20px;
  }
  ::v-deep .el-alert {
    background: transparent;
    padding: 0 8px;
    font-size: 16px;
    color: #ff5533;
    height: 18px;
    overflow: visible;
  }
}
</style>
